/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-23 15:14:53
 */
import { RecipeCategory } from '../models/recipe'
import { API_PREFIX } from './constant'
import { ContentType, MultiPartFormData, Request } from './request'

export interface CurrentPage {
  current: number
  insuranceCode?: string
  medListCodg?: string
  size: number
  name?: string
}

export interface CountryPageParams extends CurrentPage {
  drugProdname?: string
}

// 西药目录
export function getCountryPage(params: CountryPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/getMedicalWestInsuranceCountryPage`,
    method: 'GET',
    params,
  }
}
export interface ChineseMedicinePageParams extends CurrentPage {
  tcmherbName?: string
}

// 中药目录
export function getChineseMedicinePage(
  params: ChineseMedicinePageParams
): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/getMedicalChineseInsuranceCountryPage`,
    method: 'GET',
    params,
  }
}
export interface DiagnosisPageParams extends CurrentPage {
  servitemName?: string
}
// 诊疗目录
export function getDiagnosisPage(params: DiagnosisPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/getTreatmentInsuranceCountryPage`,
    method: 'GET',
    params,
  }
}
export interface MedicalPageParams extends CurrentPage {
  mcsName?: string
}

// 材料目录
export function getMedicalPage(params: MedicalPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/getMedicalSuppliesInsuranceCountryPage`,
    method: 'GET',
    params,
  }
}
export interface LimitPageParams extends CurrentPage {
  drugProdname?: string
  hilistCode?: string
}

// 医保限价目录
export function getLimitPage(params: LimitPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/getInsuranceCodeLimitPage`,
    method: 'GET',
    params,
  }
}

export interface uploadExcelParams {
  insuranceCode: string
  file?: any
  code: number
  isIncremental?: number
  listType: string
}
// 目录上传
export function uploadExcel(params: uploadExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/insurance/uploadExcel/importData`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

export interface syncInsuranceListParams {
  listType: string
  insuranceCode: string
}
// 目录同步
export function syncInsuranceList(body: syncInsuranceListParams): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/InsuranceCodeEs/syncInsuranceList`,
    method: 'POST',
    body,
  }
}

// 查询上传进度
export function uploadProgress(body: {ids:Array<number>}): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/asyncTask/searchSyncInsuranceListInRun`,
    method: 'POST',
    body,
  }
}


export interface ZjCatalogChangeImportParams {
  insuranceCode: string
  file?: any
}

export function getZjCatalogChangeImport(params: ZjCatalogChangeImportParams): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/insuranceCatalog/zjCatalogChangeImport`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

export function getZjCatalogFullImport(params: ZjCatalogChangeImportParams): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/insuranceCatalog/zjCatalogFullImport`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}
export interface SendCatalogChangeNotifyParams {
  insuranceCode: string
}

export function getSendCatalogChangeNotify(params: SendCatalogChangeNotifyParams): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/insuranceCatalog/sendCatalogChangeNotify`,
    method: 'GET',
    params,
  }
}
